module.exports = "<h2>Let's make some magic</h2><video class=\"fragment\" autoplay=\"autoplay\" loop=\"loop\" muted=\"muted\" data-ignore=\"data-ignore\"><source src=\"../../../resources/images/magic.mp4\" type=\"video/mp4\"/></video>";


//////////////////
// WEBPACK FOOTER
// ./src/slides/08-live-code/01.pug
// module id = 339
// module chunks = 1